export const INFO_WHITE_ICON = "portal/m/info_white.png";

export const DISCOUNT_BADGE_ICON = "InstamartAssets/badge.png";

export const getEmiNotAvailableOnBankCroutonState = (selectedEmiBankCode: string) => {
    return {
        title: `Only ${selectedEmiBankCode} cards are allowed for this EMI plan`,
        icon: INFO_WHITE_ICON,
    };
};

export const getEmiNotAvailableOnCardCroutonState = (selectedEmiBankCode: string) => {
    return {
        title: `Oops! This ${selectedEmiBankCode} card can’t be used for EMI plans. You can try a different card.`,
        icon: INFO_WHITE_ICON,
    };
};

export const CROUTON_CLEAR_STATE = { title: "" };

export const EMI_SUPPORTED_GATEWAY_ID = [520];

export const EMI_ELIGIBLE_PAYLOAD = {
    action: "insEligibilityNewCard",
    supportedGatewayId: EMI_SUPPORTED_GATEWAY_ID,
    isEmi: true,
    currency: "INR",
};

export const ADD_NEW_CARD_TEXTS = {
    SELECTED: "selected",
    SAVE_CARD_ON_IM_PAYMENT_MODE: "This card will be saved on Instamart payment mode",
};
